export default {"src":"/_next/static/media/strapi.4c16ec86.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};